module.exports = __webpack_public_path__ + "static/media/Qian.19e530ed.png";